import styled from 'styled-components'
import { colors, media, Typography, ZIndex } from '../../style'
import { Container } from 'react-bootstrap'

export const FixedContainer = styled.div<{ isVisible: boolean; transitionSpeed: number }>`
  position: fixed;
  background-color: ${colors.COLOUR_WHITE};
  box-shadow: 0 1px 5px 0 rgba(34, 36, 78, 0.2), 0 3px 4px 0 rgba(34, 36, 78, 0.12), 0 2px 4px 0 rgba(34, 36, 78, 0.14);

  // Fade out, then hide by setting width to 0
  transition: opacity ${(p) => p.transitionSpeed}s, width 0s ${(p) => (p.isVisible ? 0 : p.transitionSpeed)}s;
  opacity: ${(p) => (p.isVisible ? 1 : 0)};
  width: ${(p) => (p.isVisible ? '100%' : 0)};
  overflow: hidden;
  z-index: ${ZIndex.stickyHeader};
`

export const ContentContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  padding-top: 22px;
  padding-bottom: 22px;

  @media ${media.desktopAndHigher} {
    padding-top: 0;
    padding-bottom: 0;
  }
`

export const BreadcrumbContainer = styled.div`
  background: ${colors.PRIMARY_NAVY_100};
`

export const Section = styled.div`
  display: flex;
  align-items: center;
`

export const VTTSmallLogoContainer = styled.div`
  display: flex;
  align-items: center;
`

export const VTTLogoSmall = styled.img<{ isVisible: boolean; transitionSpeed: number }>`
  height: 24px;

  @media ${media.desktopAndHigher} {
    height: 120px;
    align-self: center;

    // Fade the logo in/out with a delay
    transition: opacity ${(p) => p.transitionSpeed}s ${(p) => (p.isVisible ? p.transitionSpeed / 2 : 0)}s;
    opacity: ${(p) => (p.isVisible ? 1 : 0)};
  }
`

export const VTTLogoLarge = styled.img<{ isVisible: boolean; transitionSpeed: number }>`
  margin-top: 17px;
  margin-bottom: 30px;

  @media ${media.desktopAndHigher} {
    height: 133px;
    margin-top: 32px;
    margin-bottom: 40px;

    // Animate the large logo to match the size and position of the small logo
    position: fixed;
    z-index: ${ZIndex.stickyHeader};
    transition: transform ${(p) => p.transitionSpeed}s,
      opacity ${(p) => p.transitionSpeed}s ${(p) => (p.isVisible ? 0 : p.transitionSpeed / 2)}s;
    transform: ${(p) => (p.isVisible ? 'none' : 'scale(0.665) translateY(-58px) translateX(-47px)')};
    opacity: ${(p) => (p.isVisible ? 1 : 0)};
  }
`

export const CtaTextDesktop = styled(Typography.HeaderCTA)`
  margin-right: 25px;
  text-align: right;
`

export const CtaTextMobile = styled(Typography.HeaderCTA)`
  color: ${colors.PRIMARY_RED_100};
  margin-left: 10px;
  margin-right: 32px;
`

export const StoreButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media ${media.tabletAndHigher} {
    align-self: center;
    flex-direction: row;
  }
`

export const StoreImage = styled.img`
  height: 40px;
  cursor: pointer;

  &:hover,
  &:active {
    border-radius: 6px;
    box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.07), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
  }

  &:first-child {
    margin-right: 0;
    margin-bottom: 5px;
  }

  @media ${media.tabletAndHigher} {
    &:first-child {
      margin-right: 20px;
      margin-bottom: 0;
    }
  }
`
